import {STUDENT_ENDPOINTS} from '~/constants';
import {ThunkApi} from '~/utils/thunk-api';
import {DeleteParams, FetchParams, PostParams, PutParams} from '~/utils/thunk-api/type';
import {SchoolEntity, NormalizedSchool} from '~/redux/schools/types';
import {schoolSchema} from '~/redux/schools/entity-config';

export interface FetchSchoolsParams extends FetchParams {}

export interface AddSchoolParams extends PostParams {
  data: Partial<SchoolEntity>;
}

export interface UpdateSchoolParams extends PutParams {
  data: Partial<SchoolEntity>;
  id: number;
}

const thunk = new ThunkApi<SchoolEntity, NormalizedSchool>('school', schoolSchema);
export const fetchSchools = thunk.fetch<FetchSchoolsParams>(STUDENT_ENDPOINTS.SCHOOLS);
export const addSchool = thunk.post<AddSchoolParams>(STUDENT_ENDPOINTS.SCHOOLS);
export const updateSchool = thunk.put<UpdateSchoolParams>(`${STUDENT_ENDPOINTS.SCHOOLS}/:id`);
export const deleteSchool = thunk.delete<DeleteParams>(`${STUDENT_ENDPOINTS.SCHOOLS}/:id`);
